import { create } from 'zustand'
import { v4 as uuid } from 'uuid'; 

export interface MemoryItem {
  id: string
  description: string
  image: string
  taggedProfileIds: string[]
}

interface MemoriesStore {
  memoriesMap: Record<string, MemoryItem[]>

  addMemory: (memory: Omit<MemoryItem, 'id'>) => void
  deleteMemory: (memoryId: string) => void
  updateMemory: (updatedMemory: MemoryItem) => void
  getMemories: (profileId: string) => MemoryItem[]
  getTaggedMemories: (profileId: string) => MemoryItem[]
  getAllMemories: (profileId: string) => MemoryItem[]
}

export const useMemoriesStore = create<MemoriesStore>((set, get) => ({
  memoriesMap: {
    '1': [
      {
        id: '1',
        description: 'Vacances',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: [],
      }
    ],
    '2': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '3': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '4': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '5': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '6': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '7': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '8': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '9': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '10': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '11': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: []
      }

    ],
    '12': [
      {
        id: '2',
        description: 'Sortie',
        image: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 10)}`,
        taggedProfileIds: [],
      }
    ]
  },

  addMemory: (memory) =>
    set(state => {
        //TODO me
    const newMemory: MemoryItem = { id: uuid(), ...memory }
    return {
        memoriesMap: {
          ...state.memoriesMap,
          ["me"]: [...(state.memoriesMap["me"] || []), newMemory]
        }
      }
    }),

  deleteMemory: (memoryId) =>
    set(state => ({
      memoriesMap: {
        ...state.memoriesMap,
        ["me"]: (state.memoriesMap["me"] || []).filter(m => m.id !== memoryId)
      }
    })),

  updateMemory: (updatedMemory) =>
    set(state => ({
      memoriesMap: {
        ...state.memoriesMap,
        ["me"]: (state.memoriesMap["me"] || []).map(m =>
          m.id === updatedMemory.id ? updatedMemory : m
        )
      }
    })),

  getMemories: (profileId) => {
    return get().memoriesMap[profileId] || []
  },

  getTaggedMemories: (profileId) => {
    const allProfiles = Object.values(get().memoriesMap).flat()
    return allProfiles.filter(memory => memory.taggedProfileIds.includes(profileId))
  },

  getAllMemories: (profileId) => {
    return [get().getMemories(profileId), get().getTaggedMemories(profileId)].flat().filter(Boolean)
  },
}))
